module.exports = __webpack_public_path__ + "img/checked.e11fefae.svg";